(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/gameguide/assets/javascripts/views/spelguide.js') >= 0) return;  svs.modules.push('/components/tur/gameguide/assets/javascripts/views/spelguide.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur = svs.tur || {};
  svs.tur.views = svs.tur.views || {};
  svs.tur.views.gameguide = svs.tur.views.gameguide || {};
  svs.tur.views.gameguide.Spelguide = Marionette.View.extend({
    tabView: undefined,
    tabViews: [],
    id: 'view-spelguide',
    template: _.noop,
    initialize() {
      if (!this.tabViews.length) {
        this.collection.each(article => {
          this.tabViews.push({
            caption: article.get('title'),
            view: new svs.tur.views.gameguide.SpelguideArticle({
              model: article
            }),
            id: article.get('name')
          });
        });
      }
    },
    onRender() {
      this.tabView = new svs.components.Tabs({
        tabs: this.tabViews,
        el: this.$el,
        selected: this.options.selectedTab
      });
      this.tabView.on('onChange', () => {
        this.trigger('modalContentResize');
      });
    },
    onDestroy() {
      if (window.location.pathname.indexOf('spelguide') !== -1) {
        this.options.router.navigate('/', {
          trigger: false
        });
      }
    }
  });
})(Backbone, _, svs);

 })(window);